/*
 * Copyright © 2020-2023 Ocean Galaxy Inc. All Rights Reserved.
 * @Description:
 * @LastEditors: yongqiang
 * @LastEditTime: 2023-11-22 20:22:39
 */

import { useAppSelector } from '../../app/hooks'

// 部门用户类型
interface DepartmentUser {
  user_id: string
  name: string
  [key: string]: unknown
}

// 部门类型
interface Department {
  id: string
  name: string
  children?: Department[]
  users?: DepartmentUser[]
  [key: string]: unknown
}

export const useDepartment = () => {
  const organization = useAppSelector(
    (state) => state.organization.organization
  )

  const findDepartmentById = (departments: Department[], departmentId: string): Department | null => {
    for (const department of departments) {
      if (department.id === departmentId) {
        return department
      }
      if (department.children && department.children.length > 0) {
        const result = findDepartmentById(department.children, departmentId)
        if (result) {
          return result
        }
      }
    }
    return null
  }

  const findAllUsersInDepartment = (department: Department, users: DepartmentUser[] = []): DepartmentUser[] => {
    if (department.users && department.users.length > 0) {
      users.push(...department.users)
    }
    if (department.children && department.children.length > 0) {
      for (const child of department.children) {
        findAllUsersInDepartment(child, users)
      }
    }
    return users
  }

  const findUsersByDepartmentId = (departmentId: string): DepartmentUser[] => {
    const department = findDepartmentById(organization.children, departmentId)
    if (department) {
      return findAllUsersInDepartment(department)
    }
    return []
  }

  const findUsersByDepartmentIds = (departmentIds: string[]): DepartmentUser[] => {
    const users: DepartmentUser[] = []
    for (const departmentId of departmentIds) {
      const departmentUsers = findUsersByDepartmentId(departmentId)
      users.push(...departmentUsers)
    }
    return users
  }

  return {
    findUsersByDepartmentId,
    findUsersByDepartmentIds,
    findAllUsersInDepartment,
    findDepartmentById
  }
}
